// import React, { Fragment } from 'react';
import React, {
  Fragment,
  useRef,
  useEffect,
  useContext,
  useState
} from 'react';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import t from '@jetshop/intl';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import ProductSpecifications from '@jetshop/ui/ProductSpecifications/ProductSpecifications';
import ProductList from '../../../components/ProductList/ProductList';
import Styled from './Style';

const getDocumentTitle = docUrl => {
  const [, fileName] = docUrl.match(/\/([^/?]*)(\?.*)?$/) || [];

  return fileName.replace(/-/g, ' ');
};

const ProductInfoAccordion = ({ product, selectedVariation }) => {
  const specifications = product?.customFields?.find(
    ({ key }) => key === 'specification'
  );
  const specificationList = specifications?.listValues;
  const fields = product?.customFields?.filter(field => {
    return specificationList?.includes(field.key);
  });
  const parts = product?.customFields?.find(({ key }) => key === 'reservdelar');

  const documents = product?.customFields?.find(
    ({ key }) => key === 'documents'
  );
  const articleNumberCustomStringField = {
    key: t('Art no.'),
    stringValue: product.articleNumber,
    title: t('Art no.'),
    type: 'STRING',
    __typename: 'CustomStringField'
  };

  const extendedFields = [articleNumberCustomStringField, ...fields];

  const showReviewRef = useRef(null);
  const { selectedChannel } = useContext(ChannelContext);
  var language = selectedChannel?.defaultLanguage?.culture?.split('-')[0];
  if (language === 'nb') language = 'no,nb,nn';
  const articleNumber =
    selectedVariation?.articleNumber === undefined
      ? product.articleNumber
      : selectedVariation?.articleNumber;
  var trustpilotArticlesTmp = '';
  if (product.hasVariants) {
    var articleVariantsTmp = [];
    for (var i = 0; i < product?.variants?.values.length; i++) {
      articleVariantsTmp[i] = product?.variants?.values[i].articleNumber;
    }

    trustpilotArticlesTmp = articleVariantsTmp + '';
  } else {
    trustpilotArticlesTmp = articleNumber;
  }
  const trustpilotArticles = trustpilotArticlesTmp;

  var trustpilotBusinessIdArr = [];
  trustpilotBusinessIdArr[1] = '591dbf740000ff0005a2b63b'; // Evobike.se
  trustpilotBusinessIdArr[2] = '5daefe37aa319a000155a29b'; // Evobike.no
  trustpilotBusinessIdArr[3] = '5c812492871dac0001ea131a'; // Evobike.fi
  trustpilotBusinessIdArr[4] = '5979c84c0000ff0005a789a9'; // Evobike.dk
  trustpilotBusinessIdArr[5] = '514b03b300006400052476fc'; // Rull.se
  trustpilotBusinessIdArr[6] = '58d128960000ff00059eea18'; // Ruller.no
  trustpilotBusinessIdArr[7] = '5bdad151486407000195d50b'; // Rull.fi
  trustpilotBusinessIdArr[8] = '589b88520000ff00059c56cb'; // Rull.dk
  trustpilotBusinessIdArr[9] = '59d339aa0000ff0005aca8df'; // Blimo.se
  trustpilotBusinessIdArr[10] = '5c0e2f0ca3a083000102e902'; // Blimo.no
  trustpilotBusinessIdArr[11] = '5bdad189dc66fa000134873c'; // Blimo.fi
  trustpilotBusinessIdArr[12] = '5c81244cbbc0f20001f1468a'; // Blimo.dk
  trustpilotBusinessIdArr[13] = '57babf610000ff000593c1bb'; // Sportig.se
  trustpilotBusinessIdArr[14] = '5bdacb43dc66fa00013486d2'; // Sportig.no
  trustpilotBusinessIdArr[15] = '5bdad1c3dc66fa0001348740'; // Sportig.fi
  trustpilotBusinessIdArr[16] = '5c7af553422f860001a15503'; // Sportig.dk
  trustpilotBusinessIdArr[17] = '1'; // Elmoped.se
  trustpilotBusinessIdArr[18] = '1'; // Andningslarm.se

  const trustpilotBusinessId = trustpilotBusinessIdArr[selectedChannel.id];
  var trustpilotShow;
  if (trustpilotBusinessId !== '1') {
    trustpilotShow = true;
  } else {
    trustpilotShow = false;
  }

  useEffect(() => {
    if (window.Trustpilot && trustpilotShow) {
      window.Trustpilot.loadFromElement(showReviewRef.current, true);
    }
  }, [trustpilotArticles]);

  const [open, setOpen] = useState(product.description.length > 250);

  return (
    <Styled.Wrapper>
      <Accordion>
        {({ openIndexes, handleClick, AccordionContent }) => (
          <Fragment>
            {product.description && (
              <Styled.ProductSection>
                <Styled.SectionHeading onClick={() => handleClick(0)}>
                  <span>{t('Product description')}</span>
                  <Styled.ChevronIcon isOpen={!openIndexes.includes(0)} />
                </Styled.SectionHeading>
                <AccordionContent isOpen={!openIndexes.includes(0)}>
                  {product.description.length > 250 ? (
                    <Styled.Content
                      dangerouslySetInnerHTML={{
                        __html: product.description
                      }}
                      open={!open}
                    />
                  ) : (
                    <Styled.Content
                      dangerouslySetInnerHTML={{
                        __html: product.description
                      }}
                      open={!open}
                    />
                  )}
                  {product.description.length > 250 && (
                    <Styled.ButtonContainer>
                      <Styled.Button
                        onClick={function(event) {
                          setOpen(!open);
                          window.scroll({
                            left: 0,
                            top: 680,
                            behavior: 'smooth'
                          });
                        }}
                      >
                        {function(event) {
                          setOpen(!open);
                          window.scroll(0, 0);
                        }}
                        {!open ? t('Show less') : t('Show more')}
                      </Styled.Button>
                    </Styled.ButtonContainer>
                  )}
                </AccordionContent>
              </Styled.ProductSection>
            )}
            {
              <Styled.ProductSection>
                <Styled.SectionHeading onClick={() => handleClick(1)}>
                  <span>{t('Specifications')}</span>
                  <Styled.ChevronIcon isOpen={openIndexes.includes(1)} />
                </Styled.SectionHeading>
                <AccordionContent isOpen={openIndexes.includes(1)}>
                  <Styled.SpecificationsWrapper>
                    <ProductSpecifications fields={extendedFields} />
                  </Styled.SpecificationsWrapper>
                </AccordionContent>
              </Styled.ProductSection>
            }
            {documents?.listValues && (
              <Styled.ProductSection>
                <Styled.SectionHeading onClick={() => handleClick(2)}>
                  <span>{t('Documents')}</span>
                  <Styled.ChevronIcon isOpen={openIndexes.includes(2)} />
                </Styled.SectionHeading>
                <AccordionContent isOpen={openIndexes.includes(2)}>
                  <Styled.SpecificationsWrapper>
                    {documents.listValues.map((docUrl, index) => {
                      return (
                        <Styled.DocumentLink
                          href={`/pub_docs/files${docUrl}`}
                          target="_blank"
                          rel="noreferrer"
                          key={docUrl + index}
                        >
                          {getDocumentTitle(docUrl)}
                        </Styled.DocumentLink>
                      );
                    })}
                  </Styled.SpecificationsWrapper>
                </AccordionContent>
              </Styled.ProductSection>
            )}
            {parts?.listValues?.length ? (
              <Styled.ProductSection>
                <Styled.SectionHeading onClick={() => handleClick(3)}>
                  <span>{t('Spare parts')}</span>
                  <Styled.ChevronIcon isOpen={openIndexes.includes(3)} />
                </Styled.SectionHeading>
                <AccordionContent isOpen={openIndexes.includes(3)}>
                  <Styled.SpecificationsWrapper>
                    <ProductList articleNumbers={parts.listValues} />
                  </Styled.SpecificationsWrapper>
                </AccordionContent>
              </Styled.ProductSection>
            ) : null}

            {trustpilotShow ? (
              <Styled.ProductSection>
                <Styled.SectionHeading onClick={() => handleClick(4)}>
                  <span>{t('Reviews')}</span>
                  <Styled.ChevronIcon isOpen={openIndexes.includes(4)} />
                </Styled.SectionHeading>
                <AccordionContent isOpen={openIndexes.includes(4)}>
                  <Styled.SpecificationsWrapper>
                    <div
                      ref={showReviewRef}
                      class="trustpilot-widget"
                      data-locale={selectedChannel?.language?.culture}
                      data-template-id="57177697fdb1180308e3815f"
                      data-businessunit-id={trustpilotBusinessId}
                      data-style-height="700px"
                      data-style-width="100%"
                      data-theme="light"
                      data-stars="3,4,5"
                      data-sku={trustpilotArticles}
                      data-review-languages={language}
                      // data-no-reviews="hide"
                    >
                      <a
                        href="https://se.trustpilot.com/review/evobike.se"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Trustpilot
                      </a>
                    </div>
                  </Styled.SpecificationsWrapper>
                </AccordionContent>
              </Styled.ProductSection>
            ) : null}
          </Fragment>
        )}
      </Accordion>
    </Styled.Wrapper>
  );
};

export default ProductInfoAccordion;
